import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import SeeMore from '@classify/react-core-components/SeeMore';
const PREFIX = 'DividedSeeMore';
const classes = {
  root: `${PREFIX}-root`
};
const Root = styled('div')(/* istanbul ignore next */({
  theme: {
    palette
  }
}) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '&::before, &::after': {
      content: "''",
      borderBottom: `1px solid ${palette.layout.line.divider}`,
      flexGrow: 1
    },
    // SeeMore stretches to the full width by default: let the lines take the free space.
    '&& > *': {
      width: 'auto',
      minWidth: 0
    }
  }
}));

/**
 * Classify SeeMore button centered between two divider lines.
 */
export default function DividedSeeMore(t0) {
  const $ = _c(8);
  let props;
  let translations;
  if ($[0] !== t0) {
    ({
      translations,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = translations;
  } else {
    props = $[1];
    translations = $[2];
  }
  let t1;
  if ($[3] !== translations.seeMore) {
    t1 = {
      seeMore: translations.seeMore,
      totalResults: ""
    };
    $[3] = translations.seeMore;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Root className={classes.root}><SeeMore {...props} translations={t1} /></Root>;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}